import { FocusToggleStyles } from '@smartsheet/lodestar-core';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './components/app';
import reportWebVitals from './reportWebVitals';
import '@smartsheet/lodestar-core/dist/fonts/fonts.css';
import "@smartsheet/design-tokens/dist/css/sds-tokens.css";

import './i18n';

ReactDOM.render(
  <React.StrictMode>
    <FocusToggleStyles />
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
